import type { RefObject } from "react"

import { QuerySearchInput } from "@/components/filters/QuerySearchInput"

interface ConversationSearchInputProps {
  inputRef: RefObject<HTMLInputElement | null>
  value: string
  onChange: (value: string) => void
  resetKey?: number
  hidden?: boolean
  onClear?: () => void
}

/** Renders the table-scoped all-fields search control for Conversations. */
export function ConversationSearchInput({
  inputRef,
  value,
  onChange,
  resetKey,
  hidden = false,
  onClear,
}: ConversationSearchInputProps) {
  return (
    <div
      className={
        hidden ? "hidden" : "flex w-[300px] shrink-0 items-center gap-2"
      }
    >
      <QuerySearchInput
        inputRef={inputRef}
        disabled={hidden}
        onClear={onClear}
        className="min-w-0 flex-1"
        value={value}
        onValueChange={onChange}
        resetKey={resetKey}
        searchLabel="Search conversations"
        maxLength={255}
        placeholder="Search..."
        aria-label="Search conversations"
        data-testid="conversation-search-input"
      />
    </div>
  )
}
